import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { updateShipments } from '../../redux/actions/purchaseOrders';

const DeleteShipmentModal = ({ payload, showDeleteShipmentModal, setShowDeleteShipmentModal, shipment, sendUpdateShipments, shipments, setShipments, purchaseOrderId, modalY }) => {
  const update = () => {
    let newShipments = [...shipments];
    let toUpdateIndex = newShipments.findIndex((ship) => ship.id === shipment.id);

    delete newShipments[toUpdateIndex];

    sendUpdateShipments(payload, purchaseOrderId, newShipments.filter(n => n));
    setShipments(newShipments.filter(n => n));
    setShowDeleteShipmentModal(false);
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowDeleteShipmentModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Delete Shipment?</h3>
            <p>Shipping company: { shipment.company_name }</p>
            <p>Tracking #: { shipment.tracking }</p>
            <p>Taxes/Duties: { shipment.taxes }</p>
            <p>Other: { shipment.other }</p>
            

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Delete Shipment</button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
  sendUpdateShipments: (payload, purchaseOrderId, shipments) => dispatch(updateShipments(payload, purchaseOrderId, shipments)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteShipmentModal);
